import lottie from 'lottie-web/build/player/lottie_light'
import React, { useEffect, useRef } from 'react'
import loaderAnimation from '../assets/animations/loaderAnimation.json'
import { StyledSpinner as S } from './Spinner.styles'

export const Spinner: React.FC = () => {
  const animationContainerRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    if (!animationContainerRef.current) return

    lottie.loadAnimation({
      container: animationContainerRef.current,
      animationData: loaderAnimation,
      loop: true,
    })
  }, [])

  return (
    <S.Wrapper>
      <S.ComplexAnimatedCircle ref={animationContainerRef} />
    </S.Wrapper>
  )
}
